"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var ReactDOM = require("react-dom");
var classnames_1 = require("../util/classnames");
var vdl_prefix_1 = require("../util/vdl-prefix");
var _1 = require("../util/_");
var SlideInDialog = /** @class */ (function (_super) {
    __extends(SlideInDialog, _super);
    function SlideInDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SlideInDialog.prototype.componentDidMount = function () {
        // FIXME: Use react-bootstrap fix when available
        var rootNode = ReactDOM.findDOMNode(this);
        if (rootNode && rootNode.parentNode && rootNode.parentNode.parentNode) {
            rootNode.parentNode.parentNode.className = vdl_prefix_1.vdlPrefix('slide-in-mount');
        }
    };
    SlideInDialog.prototype.render = function () {
        var _a = this.props, className = _a.className, children = _a.children, style = _a.style, dialogClassName = _a.dialogClassName, onClick = _a.onClick;
        var customProps = _1.omit(this.props, Object.keys(SlideInDialog.propTypes).concat(['onClose', 'closeable', 'dialogComponentClass']));
        delete customProps['tabIndex'];
        var modalStyle = Object.assign({}, {
            display: 'block'
        }, style);
        var dialogClasses = [
            vdl_prefix_1.vdlPrefix('slide-in-dialog')
        ];
        return (React.createElement("div", __assign({}, customProps, { title: undefined, role: "dialog", "data-dialog-id": "dialog-container", style: modalStyle, className: classnames_1.classNames(className, vdl_prefix_1.vdlPrefix('slide-in')), onClick: onClick }),
            React.createElement("div", { className: classnames_1.classNames(dialogClassName, dialogClasses) },
                React.createElement("div", { className: vdl_prefix_1.vdlPrefix('slide-in-content'), role: "document" }, children))));
    };
    SlideInDialog.propTypes = {
        dialogClassName: PropTypes.string,
        style: PropTypes.object,
        className: PropTypes.string,
        children: PropTypes.node,
        onClick: PropTypes.func
    };
    return SlideInDialog;
}(React.Component));
exports.SlideInDialog = SlideInDialog;
